/* eslint-disable no-unused-expressions */

const setElementTransition = (element, properties, duration) => {
  element.style.transitionProperty = properties;
  element.style.transitionDuration = `${duration}ms`;
  element.style.boxSizing = 'border-box';
};

const resetElementStyles = (element, styles) => {
  styles.forEach((style) => element.style.removeProperty(style));
};

const setMultipleStyles = (element, styles) => {
  Object.keys(styles).forEach((style) => {
    element.style[style] = styles[style];
  });
};

export const slideUp = (target, duration = 250) => {
  setElementTransition(target, 'height, margin, padding', duration);
  target.style.height = `${target.offsetHeight}px`;
  target.offsetHeight;

  setMultipleStyles(target, {
    overflow: 'hidden',
    height: 0,
    paddingTop: 0,
    paddingBottom: 0,
    marginTop: 0,
    marginBottom: 0,
  });

  window.setTimeout(() => {
    target.style.display = 'none';
    resetElementStyles(target, [
      'height',
      'padding-top',
      'padding-bottom',
      'margin-top',
      'margin-bottom',
      'overflow',
      'transition-duration',
      'transition-property',
    ]);
  }, duration);
};

export const slideDown = (target, duration = 250) => {
  target.style.removeProperty('display');
  let display = window.getComputedStyle(target).display;

  if (display === 'none') display = 'block';

  target.style.display = display;
  const height = target.offsetHeight;
  setElementTransition(target, 'height, margin, padding', duration);

  setMultipleStyles(target, {
    overflow: 'hidden',
    height: 0,
    paddingTop: 0,
    paddingBottom: 0,
    marginTop: 0,
    marginBottom: 0,
  });

  target.offsetHeight;
  target.style.height = `${height}px`;
  resetElementStyles(target, [
    'padding-top',
    'padding-bottom',
    'margin-top',
    'margin-bottom',
  ]);
  window.setTimeout(() => {
    resetElementStyles(target, [
      'height',
      'overflow',
      'transition-duration',
      'transition-property',
    ]);
  }, duration);
};

export const slideToggle = (target, duration = 250) => {
  if (window.getComputedStyle(target).display === 'none') {
    return slideDown(target, duration);
  }
  return slideUp(target, duration);
};

export const addClass = (el, className = 'active') => {
  el.classList.add(className);
};

export const removeClass = (el, className = 'active') => {
  el.classList.remove(className);
};

export const toggleClass = (el, className = 'active') => {
  el.classList.toggle(className);
};

export const shrinkAccordionItems = (itemList) => {
  itemList.forEach((element) => {
    const id = element.dataset.itemId;
    const body = document.getElementById(id);
    removeClass(element);
    slideUp(body);
  });
};

export const toggleFloatPanels = (floatPanels, id) => {
  floatPanels.forEach((element) => {
    if (element.dataset.id !== id) {
      removeClass(element);
    } else {
      addClass(element);
    }
  });
};

export const toggleAccordionItem = (id) => {
  const accordionItemWrapper = document.querySelector(`[data-item-id="${id}"`);
  const accordionItemBody = document.getElementById(id);
  slideToggle(accordionItemBody);
  toggleClass(accordionItemWrapper);
};

export const getTallestElement = (elementsArray) => {
  const arrayLength = elementsArray.length;
  if (arrayLength === 0) return;

  const heights = [];
  for (let i = 0; i < arrayLength; i++) {
    // set parent element display block temporary to calculate the height
    const parentElement = elementsArray[i].parentElement.style;
    elementsArray[i].style.minHeight = 'auto';
    if (parentElement.display === 'none') {
      parentElement.display = 'block';
      heights.push(elementsArray[i].offsetHeight);
      parentElement.display = 'none';
    } else {
      heights.push(elementsArray[i].offsetHeight);
    }
  }
  return Math.max(...heights);
};

export const matchHeight = (elements) => {
  const tallest = getTallestElement(elements);
  for (const element of elements) {
    element.style.minHeight = tallest + 'px';
  }
};
